import React, { useEffect, useRef, useState } from "react";
import "./styles.css";

const Carousel = ({ slides }) => {
  const carouselRef = useRef(null);
  const trackRef = useRef(null);
  const intervalRef = useRef(null);

  const [index, setIndex] = useState(0);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  /* ---------------- SLIDE POSITION ---------------- */
  useEffect(() => {
    if (!carouselRef.current || !trackRef.current) return;

    const carousel = carouselRef.current;
    const track = trackRef.current;
    const items = track.children;

    if (!items[0]) return;

    const carouselWidth = carousel.offsetWidth;
    const itemWidth = items[0].offsetWidth + 24;
    const trackWidth = track.scrollWidth;

    let translateX = 0;

    if (index === items.length - 1) {
      translateX = trackWidth - carouselWidth;
    } else {
      translateX = index * itemWidth;
    }

    track.style.transform = `translateX(-${translateX}px)`;
  }, [index]);

  /* ---------------- AUTO SCROLL ---------------- */
  useEffect(() => {
    if (isVideoPlaying) return;

    intervalRef.current = setInterval(() => {
      setIndex((prev) =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(intervalRef.current);
  }, [slides.length, isVideoPlaying]);

  /* ---------------- VIDEO EVENTS ---------------- */
  const handleVideoPlay = () => {
    setIsVideoPlaying(true);
    clearInterval(intervalRef.current);
  };

  const handleVideoPause = () => {
    setIsVideoPlaying(false);
  };

  return (
    <div className="carouselRx mt-48" ref={carouselRef}>
      <div className="carousel-track" ref={trackRef}>
        {slides.map((slide, i) => (
          <div className="carousel-item" key={i}>
            {slide.type === "image" ? (
              <img src={slide.src} alt={`slide-${i}`} />
            ) : (
              <video
                src={slide.src}
                controls
                onPlay={handleVideoPlay}
                onPause={handleVideoPause}
                onEnded={handleVideoPause}
                style={{ width: "100%", borderRadius: "12px" }}
              />
            )}
          </div>
        ))}
      </div>

      {/* INDICATORS */}
      <div className="indicators">
        {slides.map((_, i) => (
          <div
            key={i}
            className={`indicator ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
